import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M8 — PONDEUSE. Le professeur de la PRIORITÉ de cible.
 *
 *  Elle s'ancre en haut et PON D. Toutes les 2,5 s elle laisse tomber un œuf, et
 *  chaque œuf éclôt quelques secondes plus tard en Larve. Laissée tranquille, une
 *  seule Pondeuse remplit peu à peu le bas du terrain d'un essaim qu'elle n'a pas
 *  eu à tirer.
 *
 *  ── Ce qu'elle enseigne ──
 *  Que la bonne cible n'est pas toujours la plus proche ni la plus menaçante à
 *  l'instant. La Pondeuse ne fait presque rien elle-même ; l'ignorer pour
 *  s'occuper de ses œufs, c'est en laisser sortir d'autres. Le joueur apprend à
 *  couper une menace À LA SOURCE — abattre la Pondeuse vite, ou détruire les œufs
 *  avant l'éclosion (ils sont fragiles), plutôt que de courir après les Larves une
 *  fois écloses. C'est la première fois que le jeu récompense de tirer sur ce qui
 *  n'est pas encore dangereux.
 *
 *  ── Bornée, sans exception ──
 *  Quatre œufs au maximum sur toute sa vie (`brood.max`). Une pondeuse non bornée
 *  saturerait le pool et le budget de frame ; la borne fait d'elle une course
 *  contre la montre — combien d'œufs avant qu'elle tombe — et non une fuite en
 *  avant. La chaîne termine sur la Larve, qui ne pond rien.
 *
 *  ── Pourquoi un tir, léger ──
 *  Un unique tir visé de loin en loin : juste de quoi interdire de se garer sous
 *  elle pour cueillir les œufs sans risque. Sa vraie menace reste la ponte, pas
 *  le rideau. */
export default defineEnemy({
  id: 'pondeuse',
  rank: Rank.Heavy,
  hp: 220,
  visualRadius: 34,
  score: 320,
  telegraph: 1.1,
  drops: 3,
  // Ancrée haut : elle laisse tomber ses œufs de loin, et reste une cible
  // prioritaire bien visible qu'on choisit d'aller chercher ou non.
  motion: { kind: Motion.Anchor, speed: 200, holdY: 350 },
  brood: {
    // Elle pond des ŒUFS (qui écloront en Larves — la chaîne, pas la Pondeuse,
    // porte l'éclosion terminale).
    enemy: 'oeuf',
    every: 2.5,
    // ⚠️ La borne dure : quatre œufs, jamais plus, quelle que soit sa longévité.
    max: 4,
    // Sous elle : l'œuf naît juste dessous et se met à descendre vers le joueur.
    offY: -40,
  },
  emitter: {
    pattern: Pattern.Aimed,
    every: 2.4,
    count: 1,
    speed: 400,
    firstDelay: 1.6,
    family: Fam.EnemyPurple,
  },
});
